import React from 'react';

const AdminUpgradeRequestsManager = React.lazy(() => import('../pages/plan-upgrade-requests/AdminUpgradeRequestsManager'));
const UsersList = React.lazy(() => import('../pages/users/UserList'));


export const AdminRoutes = [
    { path: 'users', element: <UsersList />, name: "Users", title: "Users" },
    { path: 'plan-upgrade-requests', element: <AdminUpgradeRequestsManager />, name: "PlanUpgrades", title: "Plan Upgrades" },
    // { path: 'chat-bots', element: <ChatBots />, name: "Agents", title: "Agents" },
    // { path: 'chat-bots/chat/:chatbotId', element: <ChatBox />, name: "Chat", title: "Chat" },
    // { path: 'my-agents/chat-bots/add', element: <AddBot />, name: "addNewBot", title: "Add New Agent" },
    // { path: 'my-agents/chat-bots/chat/:chatbotId', element: <ChatBox />, name: "Chat", title: "Chat" },
    // { path: 'supervisor/user-ai-interactions', element: <SuperVisorPage />, name: "User-AI Interaction Overview", title: "User-AI Interaction Overview" },
    // { path: 'supervisor/user-ai-interactions-details', element: <SuperVisorConversationDetailsPage />, name: "User-AI Interaction Details Overview", title: "User-AI Interaction Details Overview" },
    // { path: 'pre-registrations', element: <PreRegisteredUserList />, name: "Pre Registrations", title: "Pre registered users" },
    // { path: 'pre-registrations', element: <PreRegisteredUserList />, name: "Pre Registrations", title: "Pre registered users" },
    // { path: 'pre-registrations', element: <PreRegisteredUserList />, name: "Pre Registrations", title: "Pre registered users" },

    // {
    //     title: "Doctors & Chambers",
    //     element: <Outlet />,
    //     // path: "doctors",
    //     icon: "mdi:credit-card-multiple-outline",
    //     name: "Doctors & Chambers",
    //     children: [
    //         { path: 'doctors', icon: "carbon:request-quote", title: "Doctor List", element: <DoctorList />, name: "Doctor List" },
    //         { path: 'doctors/add', icon: "carbon:request-quote", title: "Add New Doctor", element: <AddDoctor />, name: "Add Doctor" },
    //         { path: 'doctors/bulk-input', icon: "carbon:request-quote", title: "Bulk Input", element: <BulkInput />, name: "Add Bulk Input" },
    //         { path: 'chambers', icon: "carbon:request-quote", title: "Chamber List", element: <ChamberList />, name: "Doctor List" },
    //         { path: 'chambers/add', icon: "carbon:request-quote", title: "New Doctor Chamber", element: <AddDoctorChamber />, name: "New Doctor Chamber" }
    //     ]
    // }
]